
import PanelFooter from './PanelFooter.jsx';

export default PanelFooter;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBarSmall/SearchBarPanel/FullScreenPanel/PanelFooter/index.js